
import { useState, useMemo, useEffect, useRef } from 'react';
import { Container, Title, Content } from './styled';
import { Card } from '../Card';
import { BiChevronDown, BiChevronUp } from 'react-icons/bi';
import { useChat } from '../../../../../../../../contexts/chat';

export function ContentGroup(props) {

  const {
    group,
    currentCustomer,
    loadChats,
    showCard,
    isVisibility,
    onSelectedCustomer,
    selectedCustomer,
    allowAddInRoom
  } = props;

  const listRef = useRef(null);
  const { onFilter } = useChat();
  const [isHidden, setIsHidden] = useState(false);
  const [displayedPeople, setDisplayedPeople] = useState(50);
  const [scrollCreated, setScrollCreated] = useState(false);

  const handleScroll = () => {
    const element = listRef.current;
    if (element.scrollTop + element.clientHeight + 50 >= element.scrollHeight) {
      setDisplayedPeople(prevCount => prevCount + 50);
    }
  };
  useEffect(() => {
    const element = listRef.current;
    element.addEventListener('scroll', handleScroll);
    return () => element?.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (!isVisibility) return
    const currentScroll = listRef?.current?.scrollHeight;
    setScrollCreated(currentScroll >= 500);
  }, [group, isVisibility]);

  const visibleData = group?.customer_services
    .filter(
      (e) => {
        return onFilter(e, 4)
      }
    )
    ?.slice(0, displayedPeople);

  const myStateElements = useMemo(() => visibleData?.map((item) => {
    return (
      <Card
        key={item.id}
        data={item}
        loadChats={loadChats}
        active={currentCustomer?.id === item.id}
        onSelectedCustomer={onSelectedCustomer}
        selectedCustomer={selectedCustomer}
        allowAddInRoom={allowAddInRoom}
      />
    )
  }
  ), [visibleData, selectedCustomer]);

  return (
    <Container isHidden={isHidden} showCard={showCard}>
      <Title onClick={() => setIsHidden(!isHidden)}>
        <div>
          <div className='name--ref'>
            {`${group?.nomecompleto}`}
          </div>
        </div>
        <span
          className={
            `white ${group?.customer_services.length > 100 && 'bigger'}`
          }
        >
          {group?.customer_services.length}
        </span>
        {isHidden ? <BiChevronDown className='icon' /> : <BiChevronUp className='icon' />}
      </Title>
      <Content
        ref={listRef}
        isHidden={isHidden}
      >
        {myStateElements}
      </Content>
    </Container>
  );
}